var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { attrs: { gutter: 20 } },
    _vm._l(_vm.paineis, function(painel) {
      return _c("card", {
        key: painel.id,
        attrs: {
          isMyProject: _vm.isMyProject,
          title: painel.nome,
          body: painel.descricao,
          id: painel.id
        },
        on: { onClick: _vm.onClick, onEdit: _vm.onEdit, onDelete: _vm.onDelete }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-16b318d5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16b318d5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/demandas/components/ListagemPaineis.vue
// module id = null
// module chunks = 